import { render } from "./RecordTable.vue?vue&type=template&id=28e2aee4"
import script from "./RecordTable.vue?vue&type=script&lang=ts"
export * from "./RecordTable.vue?vue&type=script&lang=ts"
script.render = render

export default script